import React, { Component } from 'react';
import PropTypes from 'prop-types';

class VideoPlayer extends Component {
  static propTypes = {
    modal: PropTypes.object,
    actions: PropTypes.object
  };

  componentDidUpdate(prevProps, prevState) {
    const { open } = this.props.modal;
    if (open !== prevProps.modal.open) {
      !open ? this.stopVideo() : this.playVideo();
    }
  }

  stopVideo() {
    const { modalProps } = this.props.modal;
    const video = document.getElementById(modalProps.mp4);
    video.pause();
    video.removeAttribute('src');
    video.load();
    video.currentTime = 0;
  }

  playVideo() {
    const { modalProps } = this.props.modal;
    const video = document.getElementById(modalProps.mp4);
    video.play();
  }

  render() {
    const { open, modalProps } = this.props.modal;

    return (
      <video id={modalProps.mp4} src={`${modalProps.mp4}`} width="100%" height="90%" controls type="video/mp4">
        Your browser does not support the video tag.
      </video>
    );
  }
}

export default VideoPlayer;
